import { useDisclosure } from '@mantine/hooks'
import React, { useEffect, useRef, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'

import '../../../css/painelDispositivos/dspSimcard/dspAcoes.css'
import iconeEditarVerde from '../../../icones/iconesVersaoClara/editar_verde.svg'
import buscarBranco from '../../../icones/iconesVersaoClara/search.svg'
import buscarPreto from '../../../icones/iconesVersaoEscura/search.svg'
import iconeCopiarVerde from '../../../icones/iconesVersaoVerde/copiar.svg'
import reloadIcon from '../../../icones/iconesVersaoVerde/reload.svg'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  mudarFiltros,
  mudarManejador,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { PortadorasService } from '../../../services/http/portadoras.service.js'
import { useGlobal } from '../../../stores/useGlobal.js'
import { useCopiarParaAreaDeTransferencia } from '../../../utils/copiarTextoParaAreaDeTransferencia.jsx'
import decryptJWT from '../../../utils/decryptJWT'
import BlankSlate from '../../BlankSlate'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao.js'
import MensagemInformacao from '../../componentesModais/mensagens/mensagemInformacao.js'
import ActionIcon from '../../Mantine/ActionIcon'
import Botao from '../../Mantine/Botao'
import Group from '../../Mantine/Group'
import Input from '../../Mantine/Input'
import Popover from '../../Mantine/Popover'
import { desselecionarTodosCheckboxes } from '../../tabelaSelecao/checkboxSelecao.js'
import Table from '../../Table/index.jsx'
import AdicionarLocalizacaoPortadora from '../AdicionarLocalizacao/index.jsx'
import AlterarClassificacaoDeRede from '../AlterarClassificacaoDeRede/index.jsx'
import DetalhamentoPortadora from '../DetalhamentoLinha/index.jsx'
import Mapa from '../Mapa/index.jsx'
import HistoricoConsumo from '../Relatorios/Consumo/index.jsx'
import HistoricoConexoes from '../Relatorios/Historico/index.jsx'

import * as S from './styles.js'

let valorLimite = 50
let totalItens = 50
let contador = 0
let totalPaginas = 0

let auxDados = []

const TableprimaryKey = 'id'

const COUNT_ITEMS = true

//! Gerencia a redefinição dos filtros de portadora em dispositivos
let auxAcaoMostrarEmDispositivos = false

export default function TabelaPortadoras() {
  const {
    busca,
    filtros,
    setFiltros,
    revelarBarraFiltro,
    setRevelarBarraFiltro,
    separadorLinhaBusca,
    exportarRelatorio,
    setExportarRelatorio,
    selecionarParqueInteiro,
    setSelecionarParqueInteiro,
    mostrarAcao,
    setMostrarAcao,
    setIsLoadingGlobal,
    setMostrarNotificacao
  } = useGlobal()

  const [showCaption, setShowCaption] = useState(false)
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [limpandoSelecao, setLimpandoSelecao] = useState(false)
  const [mostrarAlertaRelatorio, setMostrarAlertaRelatorio] = useState(false)
  const [simcardsSelecionados, setSimcardsSelecionados] = useState([])
  const [simcardSelecionadoIndividual, setSimcardSelecionadoIndividual] =
    useState([])
  const [mensagemAtencao, setMensagemAtencao] = useState({
    open: false,
    mensagem: ''
  })

  const [portadorasSelecionadas, setPortadorasSelecionadas] = useState([])

  const [dados, setDados] = useState([])

  const [openedMapa, { open: openMapa, close: closeMapa }] =
    useDisclosure(false)

  const [
    openedMapaDeCalor,
    { open: openMapaDeCalor, close: closeMapaDeCalor }
  ] = useDisclosure(false)

  const codigoCliente = decryptJWT('codigoCliente')

  const queryClient = useQueryClient()

  const {
    getPortadoras,
    createReport,
    createReportSimcards,
    updateCarrierName,
    getLocation
  } = PortadorasService

  const despacho = useDispatch()

  const popoverRef = useRef(null)

  const exportarDetalhamento =
    exportarRelatorio &&
    exportarRelatorio?.acao === 'exportarDetalhamentoPortadora'

  const exportarHistoricoConexoes =
    exportarRelatorio &&
    exportarRelatorio?.acao === 'exportarHistoricoConexoesPortadoras'

  const exportarHistoricoConsumo =
    exportarRelatorio &&
    exportarRelatorio?.acao === 'exportarHistoricoConsumoPortadoras'

  const exportarRelatorioLinhas =
    exportarRelatorio && exportarRelatorio?.acao === 'exportarLinhasPortadora'

  const copiarParaAreaDeTransferencia = useCopiarParaAreaDeTransferencia()

  const mostrarMapa = mostrarAcao === 'revelarMostrarNoMapaPortadora'
  const mostrarMapaDeCalor = mostrarAcao === 'revelarMapaDeCalorPortadora'
  const mostrarAlterarClassificacaoDeRede =
    mostrarAcao === 'revelarAlterarClassificacaoDeRede'
  const mostrarAdicionarLocalizacao =
    mostrarAcao === 'revelarAdicionarLocalizacao'

  const localTema = localStorage.getItem('tema')
  let temaAtual = localTema || 'claro'
  const isEscuro = temaAtual === 'escuro'

  const COLUNAS = [
    {
      dataField: 'radio',
      text: 'Nome da Portadora',
      formatter: (cell, row) => {
        let newName = cell

        const handlePopoverOpen = () => {
          newName = cell
        }
        const handleInputChange = (e) => {
          newName = e.target.value
        }

        return (
          <S.TdComImagem>
            <span>{cell || '-'}</span>

            {codigoCliente !== '1' && (
              <S.TdIcon>
                <Popover
                  key={cell}
                  ref={popoverRef}
                  icon={iconeEditarVerde}
                  title="Editar nome da portadora"
                  onOpen={handlePopoverOpen}
                >
                  <Input
                    placeholder="Nome portadora"
                    value={newName}
                    variant="filled"
                    onChange={(e) => handleInputChange(e)}
                    maxLength={30}
                  />

                  <Group position="right" mt="xl">
                    <Botao
                      label="Cancelar"
                      uppercase={false}
                      variant="unstyled"
                      onClick={() => handleCancel()}
                    />
                    <Botao
                      disabled={false}
                      label="Salvar"
                      uppercase={false}
                      variant="unstyled"
                      onClick={() => {
                        handleSave(cell, newName, row.id)
                      }}
                    />
                  </Group>
                </Popover>
              </S.TdIcon>
            )}
          </S.TdComImagem>
        )
      }
    },
    {
      dataField: 'portadoraTipo',
      text: 'Classificação da Rede',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'rede',
      text: 'Rede',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'tecnologia',
      text: 'Tecnologia',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'mcc',
      text: 'MCC',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'mnc',
      text: 'MNC',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'lac',
      text: 'LAC',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'cellID',
      text: 'Cell ID',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'totalDeDispositivos',
      text: 'Total de dispositivos',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'online',
      text: 'Online',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'offline',
      text: 'Offline',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'latitude',
      text: 'Latitude',
      editable: false,
      formatter: (cell, col) => {
        const isAdicionarLocalizacao =
          col?.mcc === 724 &&
          col?.mnc === 88 &&
          col?.portadoraTipo === 'Privada'

        const handleAdicionarLocalizacao = () => {
          setSimcardSelecionadoIndividual([col])
          setMostrarAcao('revelarAdicionarLocalizacao')
        }

        return !cell ? (
          <S.TdComImagem>
            {isAdicionarLocalizacao ? (
              <ActionIcon
                alt="refresh"
                variant="transparent"
                onClick={handleAdicionarLocalizacao}
                icon={iconeEditarVerde}
                tooltip={{
                  label: 'Adicionar localização',
                  width: 200
                }}
              />
            ) : (
              <ActionIcon
                alt="refresh"
                variant="transparent"
                onClick={() => refreshLocation(col.id)}
                icon={reloadIcon}
                tooltip={{
                  label: 'Atualizar localização',
                  width: 200
                }}
              />
            )}
          </S.TdComImagem>
        ) : (
          cell
        )
      }
    },
    {
      dataField: 'longitude',
      text: 'Longitude',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'uf',
      text: 'Estado',
      editable: false,
      formatter: (cell) => cell || '-'
    },
    {
      dataField: 'cidade',
      text: 'Cidade',
      editable: false,
      formatter: (cell, col) => {
        return cell ? (
          <S.TdComImagem>
            <span>{cell}</span>
            <ActionIcon
              alt="copiar"
              variant="transparent"
              onClick={(e) => handleCopiar(e, col)}
              icon={iconeCopiarVerde}
              tooltip={{
                label: 'Copiar endereço para a área de transferência',
                width: 200
              }}
            />
          </S.TdComImagem>
        ) : (
          '-'
        )
      }
    }
  ]

  const corTema = () => {
    if (isEscuro) return buscarBranco
    else return buscarPreto
  }

  const handleSave = async (oldName, newName, idCarrier) => {
    if (oldName && newName && oldName !== newName) {
      updateCarrierName(idCarrier, newName)
        .then(() => {
          setDados((prev) => {
            const updatedData = prev.map((item) =>
              item.id === idCarrier ? { ...item, radio: newName } : item
            )
            return updatedData
          })

          setMostrarNotificacao({
            show: true,
            type: 'success',
            title: 'Nome editado',
            message: 'O nome da portadora foi editado com sucesso.'
          })
        })
        .catch(() => {
          setMostrarNotificacao({
            show: true,
            type: 'error',
            title: 'Falha ao editar',
            message:
              'Não foi possível editar o nome da portadora, tente novamente.'
          })
        })
    }

    popoverRef?.current?.closePopover()
  }

  const refreshLocation = async (idCarrier) => {
    setIsLoadingGlobal(true)
    getLocation(idCarrier)
      .then((response) => {
        const { lat, long } = response
        const hasData = !!(lat && long)

        setDados((prev) => {
          const updatedData = prev.map((item) =>
            item.id === idCarrier
              ? {
                  ...item,
                  latitude: hasData ? Number(lat) : '-',
                  longitude: hasData ? Number(long) : '-'
                }
              : item
          )

          setMostrarNotificacao({
            show: true,
            type: hasData ? 'success' : 'error',
            title: hasData ? 'Localização atualizada' : 'Falha na atualização',
            message: hasData
              ? 'A localização da portadora foi atualizada com sucesso.'
              : 'Não existem dados de localização para essa portadora.'
          })
          return updatedData
        })
      })
      .catch(() => {
        setMostrarNotificacao({
          show: true,
          type: 'error',
          title: 'Falha na atualização',
          message: 'Não foi possível atualizar a localização da portadora.'
        })
      })
      .finally(() => {
        setIsLoadingGlobal(false)
      })
  }

  const updateLocation = (location) => {
    const { lat, long } = location
    const hasData = !!(lat && long)

    setDados((prev) => {
      const updatedData = prev.map((item) =>
        item.id === location.id
          ? {
              ...item,
              latitude: hasData ? Number(lat) : '-',
              longitude: hasData ? Number(long) : '-'
            }
          : item
      )

      return updatedData
    })
  }

  const handleCancel = () => {
    popoverRef?.current?.closePopover()
  }

  useEffect(() => {
    if (mostrarMapa) openMapa()
  }, [mostrarMapa, openMapa])

  useEffect(() => {
    if (mostrarMapaDeCalor) openMapaDeCalor()
  }, [mostrarMapaDeCalor, openMapaDeCalor])

  const removeFiltros = () => {
    setFiltros({ vazio: 'vazio' })
    setRevelarBarraFiltro(false)
    despacho(mudarFiltros({ vazio: 'vazio' }))
    despacho(revelarBarraFiltragem(false))
  }

  useEffect(() => {
    setSelecionarParqueInteiro(false)
    if (!filtros.vazio && !filtros.GEOLOCATION && !filtros.ID_PORTADORA) {
      removeFiltros()
    }

    return () => {
      valorLimite = 50
      totalItens = 50
      contador = 0
      totalPaginas = 0
      if (auxAcaoMostrarEmDispositivos) return
      if (filtros.GEOLOCATION || filtros.ID_PORTADORA) removeFiltros()

      queryClient.removeQueries('portadoras/filter', { exact: true })
      queryClient.removeQueries('portadoras', { exact: false })
      queryClient.removeQueries('get-city', { exact: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (exportarDetalhamento) {
      const handleExportarLinhas = async () => {
        setIsLoadingGlobal(true)

        const bodyBase = {
          reportType: exportarRelatorio.tipo,
          filter: filtros,
          fetch: busca
        }

        if (bodyBase?.filter?.vazio) delete bodyBase.filter
        if (!bodyBase.fetch) delete bodyBase.fetch

        try {
          if (selecionarParqueInteiro) {
            createReport(bodyBase)
          } else {
            const auxArrayCdSimcard = simcardsSelecionados
              .map((simcard) => simcard[TableprimaryKey])
              .filter((idPortadora) => idPortadora)

            const bodySelecaoNormal = {
              ...bodyBase,
              carrierID: auxArrayCdSimcard
            }
            await createReport(bodySelecaoNormal)
          }
          setMostrarAlertaRelatorio(true)
        } catch (erro) {
          setMostrarNotificacao({
            show: true,
            type: 'error',
            autoHide: 5000,
            title: 'Falha ao gerar relatório',
            message:
              'Não foi possível gerar o relatório, tente novamente mais tarde.'
          })
        } finally {
          setExportarRelatorio({})

          setIsLoadingGlobal(false)
        }
      }

      handleExportarLinhas()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportarDetalhamento])

  useEffect(() => {
    if (exportarRelatorioLinhas) {
      const handleExportarLinhas = () => {
        setIsLoadingGlobal(true)

        const bodyBase = {
          reportType: exportarRelatorio.tipo,
          filter: filtros,
          fetch: busca,
          separadorLinhaBusca: separadorLinhaBusca
        }

        if (bodyBase?.filter?.vazio) delete bodyBase.filter
        if (!bodyBase.fetch) delete bodyBase.fetch

        let request

        if (selecionarParqueInteiro) {
          request = createReportSimcards(bodyBase)
        } else {
          const auxArrayCdSimcard = simcardsSelecionados
            .map((simcard) => simcard[TableprimaryKey])
            .filter((idPortadora) => idPortadora)

          const bodySelecaoNormal = {
            ...bodyBase,
            carrierID: auxArrayCdSimcard
          }

          request = createReportSimcards(bodySelecaoNormal)
        }

        request
          .then(() => {
            setMostrarAlertaRelatorio(true)
          })
          .catch((error) => {
            if (error.message) {
              setMensagemAtencao({
                open: true,
                mensagem: error.message
              })

              return
            }

            setMostrarNotificacao({
              show: true,
              type: 'error',
              autoHide: 5000,
              title: 'Falha ao gerar relatório',
              message:
                'Não foi possível gerar o relatório, tente novamente mais tarde.'
            })
          })
          .finally(() => {
            setExportarRelatorio({})
            setIsLoadingGlobal(false)
          })
      }

      handleExportarLinhas()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportarRelatorioLinhas])

  useEffect(() => {
    setPaginaAtual(1)
  }, [filtros, busca])

  useEffect(() => {
    despacho(mudarManejador('portadoras'))
  }, [despacho])

  const { isFetching, refetch } = useQuery(
    ['portadoras', paginaAtual, valorLimite, filtros, busca, COUNT_ITEMS],
    async () =>
      await getPortadoras(
        paginaAtual,
        valorLimite,
        filtros,
        busca,
        separadorLinhaBusca,
        COUNT_ITEMS
      ),
    {
      onSuccess: async (data) => {
        contador = (paginaAtual - 1) * valorLimite
        totalItens = data?.item_count
        totalPaginas = Math.ceil(totalItens / valorLimite)

        const novosItens = [...auxDados]

        data?.list?.forEach((portadora, index) => {
          novosItens[contador + index] = portadora
        })

        setDados(novosItens)
      },
      onError: (error) => {
        if (error.message) {
          setMensagemAtencao({
            open: true,
            mensagem: error.message
          })
        }

        console.error(error)
      },
      cacheTime: 0,
      staleTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  useEffect(() => {
    setIsLoadingGlobal(isFetching)
  }, [isFetching, setIsLoadingGlobal])

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const onClickSelecaoParqueTodo = (novoValor) => {
    if (novoValor === false) {
      desselecionarTodosCheckboxes('limparSelecao')

      setLimpandoSelecao(true)
      setShowCaption(false)
    }
    handleAlternarSelecao(novoValor)
  }

  const handleAlternarSelecao = (valor) => {
    setSelecionarParqueInteiro(valor)
    if (valor) {
      despacho(desabilitarAcoes(false))
      despacho(desabilitarAcoesCliente(true))
    } else {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(false))
    }
    setSimcardsSelecionados([])
    setPortadorasSelecionadas([])
  }

  const handleSelecionarLinha = (simcard) => {
    const selecionado = dados
      .filter((item) => item)
      .find((item) => item[TableprimaryKey] === simcard)

    if (selecionado) setSimcardsSelecionados((prev) => [...prev, selecionado])

    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  const handleDesselecionarLinha = (simcard) => {
    setSimcardsSelecionados((prev) =>
      prev.filter((item) => item[TableprimaryKey] !== simcard)
    )
    if (simcardsSelecionados.length === 1) {
      despacho(desabilitarAcoes(true))
    }
  }

  const handleSelecionarTodasLinhas = (rows) => {
    setSimcardsSelecionados((prev) => [...prev, ...rows])
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  const handleDesselecionarTodosLinhas = (rows) => {
    setSimcardsSelecionados((prev) =>
      prev.filter(
        (item) =>
          !rows.some((row) => row[TableprimaryKey] === item[TableprimaryKey])
      )
    )
    if (simcardsSelecionados.length === rows.length) {
      despacho(desabilitarAcoes(true))
    }
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <DetalhamentoPortadora
        setAuxAcaoMostrarEmDispositivos={() =>
          (auxAcaoMostrarEmDispositivos = true)
        }
        row={row}
        onUpdateLocation={updateLocation}
      />
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (limpandoSelecao) setLimpandoSelecao(false)

    if (isSelect) {
      setPortadorasSelecionadas((prev) => [...prev, row[TableprimaryKey]])
      handleSelecionarLinha(row[TableprimaryKey])
    } else {
      setPortadorasSelecionadas((prev) =>
        prev.filter((id) => id !== row[TableprimaryKey])
      )
      handleDesselecionarLinha(row[TableprimaryKey])
      if (showCaption) setShowCaption(false)
    }
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (limpandoSelecao) setLimpandoSelecao(false)

    if (isSelect && !limpandoSelecao) {
      const allIds = rows.map((r) => r.id)
      setPortadorasSelecionadas((prev) => [...prev, ...allIds])

      handleSelecionarTodasLinhas(rows)
      setShowCaption(true)
    } else {
      setPortadorasSelecionadas((prev) =>
        prev.filter((id) => !rows.some((r) => r.id === id))
      )
      handleDesselecionarTodosLinhas(rows)
      if (showCaption) setShowCaption(false)
    }
  }

  const handleCopiar = (e, col) => {
    e.stopPropagation()

    const endereco = [
      col.logradouro ? col.logradouro : '',
      col.numero && col.numero !== 0 ? col.numero : '',
      col.bairro ? col.bairro : '',
      col.cidade ? col.cidade : '',
      col.uf ? col.uf : '',
      col.cep ? col.cep : ''
    ]
      .filter((value) => value)
      .join(', ')

    if (!endereco) return

    copiarParaAreaDeTransferencia(endereco)

    setMostrarNotificacao({
      show: true,
      type: 'success',
      title: 'Endereço copiado',
      message: 'O endereço foi copiado para a área de transferência.'
    })
  }

  const handleClose = () => {
    setMostrarAcao(undefined)
    closeMapa()
    closeMapaDeCalor()
  }

  const handleMensagemAtencao = () => {
    setMensagemAtencao({
      open: false,
      mensagem: ''
    })
  }

  return (
    <div>
      {dados?.length == 0 &&
      codigoCliente == 1 &&
      (filtros.vazio || Object.keys(filtros)?.length === 0) ? (
        <BlankSlate
          mb={90}
          centralize
          icon={corTema()}
          title="Pesquise a sua portadora."
          subTitle="Encontramos muitas portadoras em nosso banco de dados. Ultilize o filtro acima e pesquise por rede, classificação de rede, tecnologia, estado ou cidade para obter resultados."
        />
      ) : (
        <S.TabelaWrapper>
          <Table
            keyField={TableprimaryKey}
            clickToSelect
            revelarContador
            itens={dados}
            colunas={COLUNAS}
            revelarBarraFiltro={revelarBarraFiltro}
            permissaoDetalhamentoLinha
            detalhamentLinha={renderDetalhamentoLinha}
            showCaption={showCaption}
            setShowCaption={setShowCaption}
            getTotalItensNaPagina={getTotalItensNaPagina}
            getLimiteNaPagina={getTotalItensNaPagina}
            pagination={{
              paginaAtual,
              valorLimite,
              totalPaginas,
              totalItens,
              contador,
              trocarPagina
            }}
            selection={{
              itensSelecionados: portadorasSelecionadas,
              modeSelection: 'checkbox',
              handleOnSelect,
              handleOnSelectAll,
              onClickSelecaoParqueTodo
            }}
          />
        </S.TabelaWrapper>
      )}
      {exportarHistoricoConexoes && (
        <HistoricoConexoes
          selecionados={simcardsSelecionados}
          opened={exportarHistoricoConexoes}
        />
      )}
      {exportarHistoricoConsumo && (
        <HistoricoConsumo
          selecionados={simcardsSelecionados}
          opened={exportarHistoricoConsumo}
        />
      )}
      {mostrarMapa && (
        <Mapa
          selecionados={simcardsSelecionados}
          title="Mostrar no mapa"
          opened={openedMapa}
          close={handleClose}
          totalItens={totalItens}
        />
      )}
      {mostrarMapaDeCalor && (
        <Mapa
          tipoMapa="calor"
          selecionados={simcardsSelecionados}
          title="Mapa de calor"
          opened={openedMapaDeCalor}
          close={handleClose}
          totalItens={totalItens}
        />
      )}
      {mostrarAlterarClassificacaoDeRede && (
        <AlterarClassificacaoDeRede
          refetchPortadoras={refetch}
          selecionados={simcardsSelecionados}
        />
      )}
      {mostrarAdicionarLocalizacao && (
        <AdicionarLocalizacaoPortadora
          refetchPortadoras={refetch}
          selecionados={simcardsSelecionados}
          setSelecionados={setSimcardsSelecionados}
          simcardSelecionadoIndividual={simcardSelecionadoIndividual}
          setSimcardSelecionadoIndividual={setSimcardSelecionadoIndividual}
        />
      )}
      {mostrarAlertaRelatorio && (
        <div id="mensagem-relatorio" className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemInformacao
              handleMensagemInformacao={() => setMostrarAlertaRelatorio(false)}
              mensagemTitulo={
                selecionarParqueInteiro || exportarRelatorioLinhas
                  ? 'O download do arquivo está sendo gerado'
                  : 'O arquivo foi gerado'
              }
              mensagemParagrafo1={
                selecionarParqueInteiro || exportarRelatorioLinhas
                  ? 'Isso pode levar alguns minutos. Você poderá baixar seu arquivo na tela de Relatórios assim que o mesmo estiver disponível.'
                  : 'Faça o download do seu arquivo na tela de Relatórios'
              }
              mensagemBotao="Voltar"
              marginTop={40}
            />
          </div>
        </div>
      )}
      {mensagemAtencao.open && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              semBotaoCancelar
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Atenção"
              mensagemBotao="Fechar"
              mensagemParagrafo1={mensagemAtencao.mensagem}
            />
          </div>
        </div>
      )}
    </div>
  )
}
